/**
 * Schema of the credential document handed to the owner once.
 * Used by the CLI that issues it and by the login form that imports it, so
 * both agree on what a valid credential looks like.
 */
import { z } from 'zod';
import { CREDENTIAL_FORMAT, KEY_ALG_LABEL } from '../constants.ts';

export const jwkPrivateSchema = z.object({
  kty: z.literal('EC'),
  crv: z.literal('P-256'),
  d: z.string().min(1),
  x: z.string().min(1),
  y: z.string().min(1),
  ext: z.boolean().optional(),
  key_ops: z.array(z.string()).optional(),
});

export const jwkPublicSchema = z.object({
  kty: z.literal('EC'),
  crv: z.literal('P-256'),
  x: z.string().min(1),
  y: z.string().min(1),
});

export const credentialSchema = z.object({
  format: z.literal(CREDENTIAL_FORMAT),
  app: z.string().min(1),
  kid: z.string().min(3).max(64),
  owner: z.string().min(1),
  label: z.string().min(1).max(120),
  alg: z.literal(KEY_ALG_LABEL),
  issuedAt: z.string().min(1),
  privateKeyJwk: jwkPrivateSchema,
  ws: z.string().min(1),
});

export type Credential = z.infer<typeof credentialSchema>;
export type JwkPublic = z.infer<typeof jwkPublicSchema>;
